export const visit = (vm, at) => {
at({ "de": { "priceComponents": { "pricePerMonth": "{{price}}/Monat", "pricePerMonthPerSeat": "{{price}}/Monat/Lizenz", "pricingLabel": "{{name}}-Preise", "subtexts": { "startsAt": "Ab" } } } });
};